import { formatDisplayDate } from '../../utils/formatDisplayDate';

/** Short month/day/year for unit card headers (Created, Completed, etc.). */
export function formatUnitShortCalendarDate(value: string | undefined | null): string {
    return formatDisplayDate(value);
}

export function normalizeUnitCreatedByName(name: string | undefined | null): string {
    return (name || '').trim();
}

/** Topics, subjects, styles, duration, and created metadata shared by all unit card tabs. */
export function deriveUnitHeaderFields(unit: {
    e251_Topics?: string[];
    e251_Subjects?: string[];
    e251_LearningStyles?: string[];
    e251_TotalDuration?: number;
    e251_CreatedAt?: string;
    e251_CreatedByName?: string;
}) {
    return {
        topics: unit.e251_Topics ?? [],
        subjects: unit.e251_Subjects ?? [],
        learningStyles: unit.e251_LearningStyles ?? [],
        totalDuration: unit.e251_TotalDuration ?? 0,
        createdAt: formatUnitShortCalendarDate(unit.e251_CreatedAt),
        createdByName: normalizeUnitCreatedByName(unit.e251_CreatedByName),
    };
}
